import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Clients from './pages/Clients';
import Login from './pages/Login';
import ClientCreate from './pages/ClientCreate';
import Projects from './pages/Projects';
import Invoices from './pages/Invoices';
import InvoicesOld from './pages/InvoicesOld';
import NewInvoice from './pages/NewInvoice';
import OfferCreate from './pages/OfferCreate';
import Index from './pages/Index';
import Rates from './pages/Rates';
import Offers from './pages/Offers';

const AppRoute = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path='/dashboard' element={<div>Dashboard</div>} />

        <Route path='/clients' element={<Clients />} />
        <Route path='/clients/create' element={<ClientCreate />} />

        <Route path='/resourcesrates' element={<Rates />} />

        <Route path='/projects' element={<Projects />} />
        <Route path='/offersold' element={<Offers />} />
        <Route path='/offers' element={<Offers />} />
        <Route path='/offers/create' element={<OfferCreate />} />

        <Route path='/index' element={<Index />} />

        <Route path='/invoices' element={<Invoices />} />
        <Route path='/invoices2' element={<InvoicesOld />} />

        <Route path='/invoices/newInvoice' element={<NewInvoice />} />
      </Route>
      <Route path='/login' element={<Login />} />
      <Route path='/' element={<Navigate to='/login' />} />
    </Routes>
  );
};

export default AppRoute;
